<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8" lg="6">
                <v-card elevation="6">
                    <v-toolbar color="primary" dark flat>
                        <v-toolbar-title>
                            <v-icon left>mdi-information</v-icon>
                            Sessão de Carregamento: {{ id }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="$emit('close')">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>

                    <v-card-text>
                        <v-alert v-if="!data" type="error" border="left" colored-border elevation="2">
                            <div class="text-center">
                                <v-icon color="error" large>mdi-alert-circle</v-icon>
                                <div class="my-2 font-weight-bold">Ops!</div>
                                Não foi possível encontrar as informações para esta sessão.
                            </div>
                        </v-alert>

                        <template v-else>

                            <div v-if="data.charger || data.plug" class="mb-4">
                                <div class="font-weight-bold mb-1" style="font-size: 1.1em;">Carregador / Plug</div>
                                <div>
                                    <span v-if="data.charger">
                                        <v-chip color="green lighten-4" text-color="green darken-4" class="font-weight-bold mr-2" small>
                                            <v-icon left small color="green darken-2">mdi-ev-station</v-icon>
                                            {{ data.charger.name }}
                                        </v-chip>
                                    </span>
                                    <span v-if="data.plug">
                                        <v-chip color="blue lighten-4" text-color="blue darken-4" class="font-weight-bold" small>
                                            <v-icon left small color="blue darken-2">mdi-power-plug</v-icon>
                                            Plug {{ data.plug }}
                                        </v-chip>
                                    </span>
                                </div>
                            </div>


                            <v-alert dense outlined color="secondary" border="left" elevation="6" class="mb-4 text-body-1 font-weight-bold">
                                <div class="d-flex align-center flex-wrap">
                                    <div class="mr-4">
                                        <v-icon color="primary" left>mdi-calendar-clock</v-icon>
                                        {{ data.dateTime }}
                                    </div>
                                    <div class="mr-4">
                                        <v-icon color="success" left>mdi-currency-brl</v-icon>
                                        R$ {{ data.paymentValue }}
                                    </div>
                                    <v-spacer></v-spacer>
                                    <div class="d-flex align-center">
                                        <template v-if="data.status === HistoryStatus.PROCESSED">
                                            <v-icon color="success" left large>mdi-check-circle</v-icon>
                                            <span class="font-weight-bold text--success">Sucesso</span>
                                        </template>
                                        <template v-else-if="data.status === HistoryStatus.PROCESSED_MANUAL">
                                            <v-icon color="info" left large>mdi-check-circle</v-icon>
                                            <span class="font-weight-bold text--info">Processado Manual</span>
                                        </template>
                                        <template v-else-if="data.status === HistoryStatus.NEED_PROCESS">
                                            <v-progress-circular indeterminate color="warning" size="24" class="mr-2" />
                                            <span class="font-weight-bold text--warning">Processando</span>
                                        </template>
                                        <template v-else>
                                            <v-icon color="error" left large>mdi-alert-circle</v-icon>
                                            <span class="font-weight-bold text--error">Erro</span>
                                        </template>
                                    </div>
                                </div>
                            </v-alert>

                            <BatteryProgress v-if="data.car && data.car.percentStart != null && data.car.percent != null" class="mb-4" :start="data.car.percentStart"
                                :end="data.car.percent" :minutesTo80Percent="data.car.minutesTo80Percent" />

                            <TimeProgress v-if="data.car && data.car.minutesCharger != null && data.car.minutesConnected != null" class="mb-4" :charging="data.car.minutesCharger"
                                :connected="data.car.minutesConnected" />

                            <v-list two-line>
                                <v-divider></v-divider>
                                <template v-if="data.car">
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold">Consumo</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.car.consumption }} kWh</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-flash</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold">Potência Máxima</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.car.maximumPower }} W</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-lightning-bolt</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item v-if="data.car.nfc">
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold">NFC</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.car.nfc }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-nfc-variant</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                    <v-list-item v-if="data.car.idUser">
                                        <v-list-item-content>
                                            <v-list-item-title class="font-weight-bold">Usuário</v-list-item-title>
                                            <v-list-item-subtitle>{{ data.car.idUser }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                        <v-list-item-icon>
                                            <v-icon color="primary">mdi-account</v-icon>
                                        </v-list-item-icon>
                                    </v-list-item>
                                </template>
                                <v-divider></v-divider>
                            </v-list>
                        </template>
                        <div v-if="data && data.idPayment" class="mt-6">
                            <v-btn color="success" block large class="font-weight-bold" :to="`/payment/${data.idPayment}`" style="width: 100%;">
                                <v-icon left>mdi-credit-card</v-icon>
                                Ver Detalhes do Pagamento
                            </v-btn>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import HistoryStatus from "@/enum/HistoryStatus";
import TimeProgress from './TimeProgress.vue';
import BatteryProgress from './BatteryProgress.vue';

export default {
    components: { BatteryProgress, TimeProgress },
    props: {
        id: {
            type: Number,
        },
    },

    data() {
        return {
            HistoryStatus,
            data: null,
        }
    },

    watch: {
        id: {
            immediate: true,
            handler() {
                this.get();
            },
        },
    },

    methods: {
        get() {
            if (this.id) {
                this.$http
                    .get(`api/v3/history/${this.id}`)
                    .then((result) => {
                        this.data = result;
                    })
                    .catch(() => {
                        this.data = null;
                    });
            } else {
                this.data = null;
            }
        },
    },
};
</script>